import { BaseModel } from "@uranda/commons";

export interface Lead extends BaseModel {
  id: string;
  firstname: string;
  address?: string;
  lastname: string;
  email?: string;
  /** Lingua del cliente (come da email/SMS). Codice ISO grezzo: normalizzare con normalizeLang(). */
  language?: string;
  phoneNumber?: string;
  /** Pannello clinica: il telefono è nascosto perché l'utente non ha VIEW_CONTACT_INFO (non perché il lead è bloccato). */
  contactInfoRestricted?: boolean;
  leadSource?: LeadSource;
  leadType?: LeadType;
  status?: LeadStatus;
  hasRequest?: boolean;
  disabledAt?: string;
  city?: string;
  district?: string;
  region?: string;
  country?: string;
  countryCode?: string;
  emailVerifiedAt?: string;
  phoneNumberVerifiedAt?: string;
  partnerName?: string;
  quoteRequestDistrict?: string;
  quoteRequestRegion?: string;
  quoteRequestCountry?: string;
  /** Istante di purge dei dati sensibili (retention). Se valorizzato, i dati sono stati rimossi. */
  purgedAt?: string;
  /** Valorizzato se il cliente ha cancellato i propri dati: la richiesta va mostrata come "Cancelled by client". */
  cancelledAt?: string;
}

export enum LeadSource {
  WEBSITE = 'WEBSITE',
  FACEBOOK = 'FACEBOOK'
}

export enum LeadStatus {
  NEW = 'NEW',
  PROCESSING = 'PROCESSING',
  CONVERTED = 'CONVERTED',
  ARCHIVED = 'ARCHIVED',
  SUPPORT = 'SUPPORT'
}

export enum LeadType {
  CONTACT_REQUEST = "CONTACT_REQUEST",
  QUOTE_REQUEST = "QUOTE_REQUEST"
}

export enum VerificationFilter {
  ALL = 'ALL',
  VERIFIED = 'VERIFIED',
  NOT_VERIFIED = 'NOT_VERIFIED'
}

export enum LeadReportMotivation {
  INVALID_NUMBER = 'INVALID_NUMBER',
  WRONG_INTERNATIONAL_PREFIX = 'WRONG_INTERNATIONAL_PREFIX',
  NO_ANSWER = 'NO_ANSWER',
  SENT_BY_MISTAKE = 'SENT_BY_MISTAKE',
  CHANGED_MIND = 'CHANGED_MIND',
  DOES_NOT_RECEIVE_SMS = 'DOES_NOT_RECEIVE_SMS',
  CANNOT_FIND_SMS = 'CANNOT_FIND_SMS',
  DIFFICULTY_FILLING_FORM = 'DIFFICULTY_FILLING_FORM',
  GETS_SPAM = 'GETS_SPAM',
  INTERESTED_LATER = 'INTERESTED_LATER',
  NOT_DIRECTLY_INTERESTED = 'NOT_DIRECTLY_INTERESTED'
}

export const LeadReportMotivationLabels: Record<LeadReportMotivation, string> = {
  [LeadReportMotivation.INVALID_NUMBER]: 'Invalid number',
  [LeadReportMotivation.WRONG_INTERNATIONAL_PREFIX]: 'Wrong international prefix',
  [LeadReportMotivation.NO_ANSWER]: 'No answer',
  [LeadReportMotivation.SENT_BY_MISTAKE]: 'Sent by mistake',
  [LeadReportMotivation.CHANGED_MIND]: 'Changed mind',
  [LeadReportMotivation.DOES_NOT_RECEIVE_SMS]: 'Does not receive SMS',
  [LeadReportMotivation.CANNOT_FIND_SMS]: 'Cannot find SMS',
  [LeadReportMotivation.DIFFICULTY_FILLING_FORM]: 'Difficulty filling form',
  [LeadReportMotivation.GETS_SPAM]: 'Gets spam',
  [LeadReportMotivation.INTERESTED_LATER]: 'Interested later',
  [LeadReportMotivation.NOT_DIRECTLY_INTERESTED]: 'Not directly interested'
};
